module.exports = __webpack_public_path__ + "static/media/new_login.26bab53e.svg";